import resolveConfig from "tailwindcss/resolveConfig";
import tailwindConfig from "../../tailwind.config";

export const getTailwindColors = () => {
  const fullConfig = resolveConfig(tailwindConfig);
  return fullConfig.theme.colors;
};
